// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_dict from "../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as LocationConfig$Showside from "../utils/LocationConfig.bs.js";
import * as Webapi__Dom__HtmlElement from "../../../../node_modules/rescript-webapi/lib/es6_global/src/Webapi/Dom/Webapi__Dom__HtmlElement.bs.js";
function getPage(param) {
  return Caml_option.nullable_to_opt(document.querySelector("html"));
}
function getClassName(param) {
  return "QVTW__body-no-scroll";
}
var callbacks = {};
function usePausePageScrolling(param) {
  var namespace = LocationConfig$Showside.useNamespaceAsString(undefined);
  React.useEffect(function () {
    var runCallbacks = function (el) {
      Belt_Array.forEach(Belt_Option.getWithDefault(Js_dict.get(callbacks, namespace), []), function (callback) {
        Curry._1(callback, el);
      });
    };
    var addClassName = function (param) {
      Belt_Option.forEach(Caml_option.nullable_to_opt(document.querySelector("html")), function (page) {
        page.setAttribute("class", (page.className + " QVTW__body-no-scroll").trim());
      });
      runCallbacks(undefined);
    };
    var forceFirefoxEnableScrolling = function (param) {
      var style = Belt_Option.map(Belt_Option.flatMap(Caml_option.nullable_to_opt(document.querySelector("html")), Webapi__Dom__HtmlElement.ofElement), function (prim) {
        return prim.style;
      });
      Belt_Option.forEach(style, function (__x) {
        __x.setProperty("overflow", "auto");
      });
      setTimeout(function (param) {
        Belt_Option.map(style, function (__x) {
          return __x.removeProperty("overflow");
        });
      }, 42);
    };
    var removeClassName = function (param) {
      Belt_Option.forEach(Caml_option.nullable_to_opt(document.querySelector("html")), function (page) {
        page.setAttribute("class", page.className.replace(new RegExp("QVTW__body-no-scroll"), "").trim());
      });
      forceFirefoxEnableScrolling(undefined);
      runCallbacks(undefined);
    };
    addClassName(undefined);
    return removeClassName;
  }, []);
}
function PausePageScrolling(Props) {
  usePausePageScrolling(undefined);
  return null;
}
PausePageScrolling.displayName = "PausePageScrolling";
function useIsPausing(param) {
  var namespace = LocationConfig$Showside.useNamespaceAsString(undefined);
  var getState = function (el) {
    return Belt_Option.getWithDefault(Belt_Option.map(el, function (page) {
      return page.classList.contains("QVTW__body-no-scroll");
    }), false);
  };
  var match = React.useState(function () {
    return getState(Caml_option.nullable_to_opt(document.querySelector("html")));
  });
  var setIsPausing = match[1];
  React.useEffect(function () {
    var setIsPausing$1 = function (param) {
      Curry._1(setIsPausing, function (param) {
        return getState(Caml_option.nullable_to_opt(document.querySelector("html")));
      });
    };
    callbacks[namespace] = Belt_Array.concat(Belt_Option.getWithDefault(Js_dict.get(callbacks, namespace), []), [setIsPausing$1]);
    return function (param) {
      callbacks[namespace] = Belt_Array.keep(Belt_Option.getWithDefault(Js_dict.get(callbacks, namespace), []), function (callback) {
        return callback !== setIsPausing$1;
      });
    };
  }, []);
  return match[0];
}
var make = PausePageScrolling;
export { getPage, getClassName, callbacks, usePausePageScrolling, make, useIsPausing };
/* react Not a pure module */